import { JpegIcon, PdfIcon, PngIcon, SvgIcon } from "@/icons/export";
import type { ExportMenuItem } from "./types";

export const MENU_GAP = 8;
export const VIEWPORT_MARGIN = 8;
export const MENU_WIDTH = 184;
export const EXPORT_MENU_ITEMS: ExportMenuItem[] = [
    {
        icon: PdfIcon,
        label: "PDF",
        format: "pdf",
    },
    {
        icon: PngIcon,
        label: "PNG",
        format: "png",
    },
    {
        icon: JpegIcon,
        label: "JPEG",
        format: "jpeg",
    },
    {
        icon: SvgIcon,
        label: "SVG",
        format: "svg",
    },
];
